import { render } from "./ScoreGrid.vue?vue&type=template&id=19a5cfb0&ts=true"
import script from "./ScoreGrid.vue?vue&type=script&lang=ts"
export * from "./ScoreGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__